import { defineMessages } from "react-intl";

const messages = defineMessages({
  subtitle: {
    id: "dashboard.cards.openStageDealAmount.subtitle",
    defaultMessage: "{entireOrg, select, true {All Users} other {{name}}}",
    description: "Subtitle of the Open Stage Deal Amount card",
  },
  unknown: {
    id: "dashboard.cards.openStageDealAmount.subtitle.unknown",
    defaultMessage: "Unknown",
    description:
      "Unknown title for the case when ranking a team for Subtitle of the Open Stage Deal Amount card",
  },
});

export default messages;
